import type { CompanyApi } from "../../../../hooks/useCompanyApi"
import { unwrap } from "../../../../lib/api/errors"

/** Turn whatever Eden hands back for a `text/plain` export into a string. */
async function bodyToText(body: unknown): Promise<string> {
  if (typeof body === "string") return body
  if (body instanceof Blob) return body.text()
  if (body instanceof Response) return body.text()
  throw new Error("Export returned an unexpected body")
}

/**
 * Fetch the meeting transcript as plain text through the tenant client and
 * write it to the clipboard. Throws an Error carrying the API message on
 * failure so callers can pass it through `extractErrorMessage`.
 */
export async function copyTranscript(
  company: CompanyApi,
  meetingId: string,
  clipboard: Pick<Clipboard, "writeText"> = navigator.clipboard,
): Promise<void> {
  const result = await company.meetings({ id: meetingId }).export.get({
    query: { format: "txt", content: "transcript" },
  })
  const text = await bodyToText(unwrap(result))
  await clipboard.writeText(text)
}
